<template>
  <div class="product-photos">
        <div v-if="product.filePivots.length" class="products-images">
          <b-image
            v-for="(file, index) in product.filePivots"
            :key="index + '_' + file.id"
            ratio="1by1"
            :src="getImageBySize(file.file, 'w2000').src"
            :webp-fallback="getImageBySize(file.file, 'w2000').webpFallback"
            class="skeleton-image-placeholder"
            lazy
            :alt="product.product.description.name"
          >
            <template #placeholder>
              <b-skeleton />
            </template>
          </b-image>
        </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  }
}
</script>
